/**
 * Banner shown when the browser is offline or the WebSocket is reconnecting.
 * Shows sync status so the user knows their data is current.
 */

import { useAppStore } from '../store/app';
import { useSyncStore } from '../store/sync';

export function OfflineIndicator() {
  const isOnline = useAppStore((s) => s.isOnline);
  const syncStatus = useSyncStore((s) => s.status);
  const pendingCount = useSyncStore((s) => s.pendingCount);

  // Offline takes priority
  if (!isOnline) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 py-1.5 text-sm font-medium"
        style={{
          backgroundColor: 'var(--warning)',
          color: '#000',
          paddingTop: 'max(0.375rem, var(--sat))',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="1" y1="1" x2="23" y2="23" />
          <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
          <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
          <path d="M10.71 5.05A16 16 0 0 1 22.56 9" />
          <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
          <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
          <line x1="12" y1="20" x2="12.01" y2="20" />
        </svg>
        You are offline
        {pendingCount > 0 && (
          <span className="ml-1 text-xs opacity-75">({pendingCount} pending)</span>
        )}
      </div>
    );
  }

  // Show reconnecting indicator
  if (syncStatus === 'reconnecting') {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-2 py-1.5 text-sm font-medium"
        style={{
          backgroundColor: 'var(--accent-soft)',
          color: 'var(--accent)',
          paddingTop: 'max(0.375rem, var(--sat))',
        }}
      >
        <svg className="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 12a9 9 0 11-6.219-8.56" />
        </svg>
        Reconnecting...
      </div>
    );
  }

  // Connected: no indicator
  return null;
}
